module.exports = __webpack_public_path__ + "assets/img/37_1636.87e942e6.jpg";